<div class="loading-bar" [class.finished-loading]="!loadingIndicatorService.pageLoading"></div>
